import { SVGProps, Ref, forwardRef } from 'react';

export const StarFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m12.672 10.721-.136-.558.466-.392c2.16-1.816 3.24-2.723 2.952-3.588-.286-.865-1.704-.977-4.54-1.202l-.602-.047-.243-.573C9.475 1.787 8.928.5 8 .5S6.525 1.787 5.431 4.36l-.243.574-.603.047C1.75 5.206.332 5.318.045 6.183s.793 1.772 2.952 3.588l.437.367-.141.583c-.658 2.713-.988 4.07-.237 4.604.75.534 1.964-.192 4.393-1.644l.533-.319.533.32c2.429 1.451 3.643 2.177 4.393 1.643.75-.535.422-1.891-.236-4.604"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
StarFilledSize16Glyph.displayName = 'StarFilledSize16Glyph';
